module.exports = __webpack_public_path__ + "img/dunes.81f67ba3.svg";